export default "__VITE_ASSET__TCjk_UNb__"